import { AIButton } from "@similarweb/ai-kit";
import { Stop } from "@similarweb/icons";
import { CountryChipItem } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import type { ICountryObject } from "app/services/CountryService";

import {
    ComposerCountryRow,
    RunComposerCard,
    RunComposerText,
    StepHeading,
    StopButtonWrapper,
} from "./styledComponents";
import { translateWithFallback as t } from "./translateWithFallback";

type RunningComposerProps = {
    description: string;
    selectedCountry: ICountryObject;
    canStop: boolean;
    onStop: () => void;
};

// Figma node 141:6201 — the composer's own arrow button becomes a stop button while the agent
// runs: the destructive action now lives where the user already looks, instead of a separate
// "Cancel the process" button competing with "Close this view for now".
export const RunningComposer = ({ description, selectedCountry, canStop, onStop }: RunningComposerProps) => (
    <>
        {/* No separate eyebrow here — same duplicate as the compose screen: the page's own
            title above this card already reads "Create a custom industry". */}
        <StepHeading>{t("market.builder.v2.progress.title", "Let's find websites that match")}</StepHeading>
        <RunComposerCard data-automation="market-builder-v2-running-composer">
            <Stack
                gap="8px"
                flex="1 1 auto"
                minWidth="0"
            >
                <RunComposerText>{description}</RunComposerText>
                <ComposerCountryRow data-automation="market-builder-v2-running-composer-country">
                    <CountryChipItem
                        id={selectedCountry.id}
                        text={selectedCountry.text}
                        hideActionButton
                    />
                </ComposerCountryRow>
            </Stack>
            <StopButtonWrapper data-automation="market-builder-v2-stop-btn">
                <AIButton
                    variant="primary"
                    size="medium"
                    icon={<Stop size="xs" />}
                    disabled={!canStop}
                    onClick={onStop}
                />
            </StopButtonWrapper>
        </RunComposerCard>
    </>
);
